import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectDropdown from "../SelectDropdown";

const Country = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("countries");
  const [data, setData] = useState(undefined);
  const [code, setCode] = useState("");
  const [cDesc, setCDesc] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCode, setEmptyCode] = useState(false);
  const [emptyDesc, setEmptyDesc] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setCode("");
    setCDesc("");
    setDuplicateVal(false);
  };

  function setSelectedRow(rowid) {

    axios
      .get(`${BASE_URL}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setCode(
          res.data.country[0].country_code
            ? res.data.country[0].country_code
            : ""
        );
        setCDesc(
          res.data.country[0].country_description
            ? res.data.country[0].country_description
            : ""
        );
        setBtnActive(false);
      });
  }

  const handleSave = async (event) => {
    event.preventDefault();
    if (code.length === 0) {
      toast.error("Country Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCode(true);
      setEmptyInput(true);
    } else {
      setEmptyCode(false);
    }

    if (cDesc.length === 0) {
      toast.error("Country Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = { country_code: code, country_description: cDesc };
      const duplicate = await data.some((el) => el.CountCode === code);
      if (duplicate !== true) {
        axios
          .post(`${BASE_URL}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This Country code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = { country_code: code, country_description: cDesc };
      axios
        .post(
          `${BASE_URL}${pageComponent}/update/${selectRowData.country.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setTimeout(window.location.reload.bind(window.location), 2000);
    }
  };

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.countries);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken, pageComponent]);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${BASE_URL}${pageComponent}/destroy/${selectRowData.country.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };
  const tTitle = ["Country Code ", "Country Name"];
  const columns = ["country_code", "country_description"];
  const handleButtonClickPDF = () => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(columns) || columns.length === 0) {
      // Handle the scenario where the data or selected keys are invalid or empty
      toast.error("Invalid data or selected keys for export.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filteredRows = data.map(obj => {
      const filteredRow = {};
      columns.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          filteredRow[key] = obj[key];
        }
      });
      return filteredRow;
    });

    const doc = new jsPDF();
    const rows = filteredRows.map(obj => Object.values(obj));

    const columnStyles = {}; // Object to hold column styles

    // Set cell widths (adjust widths as needed)
    columns.forEach(key => {
      columnStyles[key] = { cellWidth: 30 }; // Change width as per your requirement
    });

    doc.autoTable({
      columns: tTitle.map(key => ({ header: key, dataKey: key })),
      body: rows,
      columnStyles,
      startY: 5, // Adjust the starting Y position for the table
      // ... other configuration options
    });

    // Save the PDF file
    const dateTime = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fileName = `Country_PDF_Report_${dateTime}.pdf`;
    doc.save(fileName);
  };
  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">

                  <Form.Label>Country Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Count. Code"
                    name="countrycode"
                    readOnly={selectRowData !== "" ? true : false}
                    value={code}
                    className={emptyCode === true ? "border-red2" : ""}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Country Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Count. Name"
                    name="CountDesc"
                    value={cDesc}
                    className={emptyDesc === true ? "border-red2" : ""}
                    onChange={(e) => setCDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">

                {props.selectedAuthority && props.selectedAuthority.new === 1 ? (
                  <>
                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={selectRowData !== "" ? edditRow : handleSave}
                      disabled={btnActive}
                    >
                      Save
                    </Button>

                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={createNewRow}
                    >
                      New
                    </Button>
                  </>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.edit === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={edditRow}
                    disabled={btnActive}
                  >
                    Update
                  </Button>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.delete === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={deleteRow}
                    disabled={btnActive}
                  >
                    Delete
                  </Button>
                ) : null}

                {props.selectedAuthority && props.selectedAuthority.print === 1 ? (
                  <Button className="ms-3" variant="primary" onClick={handleButtonClickPDF}>
                    Print
                  </Button>
                ) : null}

                {/* <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button> */}
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Country;
